import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProjects, setSelectedProject } from '../actions';
import { 
  findProject, 
  filterProjectByName, 
  filterProjectByNumber, 
  filterProjectById,
  getProjectId,
  getProjectName,
  getProjectNumber,
  standardizeProject,
  isValidProject
} from '../utils/projectUtils';

export const useProjects = () => {
  const dispatch = useDispatch();
  const { projects, projectsLoading, projectsError, selectedProject } = useSelector(state => state.weldData);

  // Load all projects from the API
  const loadProjects = useCallback(() => {
    dispatch(fetchProjects());
  }, [dispatch]);

  // Select a specific project
  const selectProject = useCallback((project) => {
    dispatch(setSelectedProject(project));
  }, [dispatch]);

  // Filter and select project by project number
  const filterProjectByNumberLocal = useCallback((projectNumber) => {
    
    if (projects && projects.length > 0) {
      const filteredProject = filterProjectByNumber(projects, projectNumber);
      if (filteredProject) {
        selectProject(filteredProject);
        return filteredProject;
      } else {
      }
    } else {
    }
    return null;
  }, [projects, selectProject]);

  // Get project by ID
  const getProjectById = useCallback((projectId) => {
    if (projects && projects.length > 0) {
      return filterProjectById(projects, projectId);
    }
    return null;
  }, [projects]);

  // Get project by name
  const getProjectByName = useCallback((projectName) => {
    if (projects && projects.length > 0) {
      return filterProjectByName(projects, projectName);
    }
    return null;
  }, [projects]);

  // Comprehensive project finder
  const findProjectLocal = useCallback((searchValue) => {
    
    if (projects && projects.length > 0) {
      const foundProject = findProject(projects, searchValue);
      return foundProject;
    } else {
    }
    return null;
  }, [projects]);

  // Get standardized project object
  const getStandardizedProject = useCallback((project) => {
    return standardizeProject(project);
  }, []);

  // Validate project object
  const validateProject = useCallback((project) => {
    return isValidProject(project);
  }, []);

  // Get project ID from selected project
  const getSelectedProjectId = useCallback(() => {
    if (selectedProject) {
      return getProjectId(selectedProject);
    }
    return null;
  }, [selectedProject]);

  // Get project name from selected project
  const getSelectedProjectName = useCallback(() => {
    if (selectedProject) {
      return getProjectName(selectedProject);
    }
    return null;
  }, [selectedProject]);

  // Load projects on component mount
  useEffect(() => {
    if (projects.length === 0) {
      loadProjects();
    }
  }, [loadProjects, projects.length]);

  return {
    projects,
    projectsLoading,
    projectsError,
    selectedProject,
    loadProjects,
    selectProject,
    filterProjectByNumber: filterProjectByNumberLocal,
    getProjectById,
    getProjectByName,
    findProject: findProjectLocal,
    getStandardizedProject,
    validateProject,
    getSelectedProjectId,
    getSelectedProjectName
  };
}; 